/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
import { AnalyticsConstant } from '../constants';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

export default class AnalyticsService implements ltFramework.IAnalyticsService {
	public collectAnalytics(object: object): void {
		if (object) {
			window.appEventData = window.appEventData || ([] as ltFramework.IAppEventData[]);
			window.appEventData.push(object);
		}
	}

	public satelliteTrack(eventName: string, digitalDataObject: object): void {
		if (eventName && digitalDataObject) {
			window._satellite.track(eventName, digitalDataObject);
		}
	}

	public handleFeedbackLink(object: JQuery): void {
		const classAttr = object.attr('class');
		if (classAttr && String(classAttr).includes('link_event_feedback')) {
			this.linkUserInfo(object);
		}
	}

	public linkUserInfo(object: JQuery): void {
		let targetVal: string | undefined = $(object).attr('href');
		let memberId = '';
		const memberData = window.ef.profileStore?.getInitialData();
		if (memberData && memberData.initialized && memberData.memberDetails) {
			memberId = memberData.memberDetails.memberId.toString();
		}
		if (targetVal && memberId) {
			// Replace adobe Id
			targetVal = targetVal.replace('__adobeid__', this.getMcId());
			// Replace Member ID
			targetVal = targetVal.replace('__mid__', memberId);
			$(object).attr('href', targetVal);
		}
	}

	public fireFormViewedEvent(formType: string, formName: string, formLeadType: string) {
		const formViewedEventData = {
			form: {
				formType,
				formName,
				formLeadType
			},
			event: 'Form Viewed'
		};
		this.collectAnalytics(formViewedEventData);
	}

	public fireFormSucceededEvent(formType: string, formName: string, formLeadType: string) {
		const formSubmissionSuccessEventData = {
			form: {
				formType,
				formName,
				formLeadType
			},
			event: 'Form Submission Succeeded'
		};
		this.collectAnalytics(formSubmissionSuccessEventData);
	}

	public fireFormFailedEvent(
		formType: string,
		formName: string,
		formLeadType: string,
		formError: string
	) {
		const formSubmissionFailEventData = {
			form: {
				formType,
				formName,
				formLeadType,
				formError
			},
			event: 'Form Submission Failed'
		};
		this.collectAnalytics(formSubmissionFailEventData);
	}

	public getMcId(): string {
		const mcId = lookupVisitorId();
		return mcId || waitForMcId();
	}
}

export const analyticsService = new AnalyticsService();

function waitForMcId(id = ''): string {
	if (!id) {
		setTimeout(() => {
			const recheckID = lookupVisitorId();
			waitForMcId(recheckID);
		}, 0);
	}
	return id;
}

// local variable in this module to cache the id of the user
let cachedMcId = '';

function lookupVisitorId(): string {
	if (cachedMcId) {
		return cachedMcId;
	}
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	cachedMcId
		= window.Visitor?.getInstance(
			AnalyticsConstant.marketingCloudInstanceId
		).getMarketingCloudVisitorID() ?? '';

	return cachedMcId;
}
